module.exports = __webpack_public_path__ + "static/media/support2.d0119310.svg";